import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllUserRole = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/role');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const getUserRoleByID = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.get(`/role/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const createUserRole = async (name) => {
    try {
        await isAccessTokenValid();
        const response = await api.post('/role', name);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updateUserRole = async (id, name) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/role/${id}`, name);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const deleteUserRole = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.delete(`/role/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
